/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import styles from './App.module.scss';
import Stepper from './components/stepper/Stepper';
import HomePage from './pages/Home/Home';
import ReportPage from './pages/ReportPage/Report';
import RiskTransfer from './pages/RiskTransfer/RiskTransfer';

const App: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const pathValue = path.replace(/\//g, '');

    if (pathValue === '') {
      document.title = 'Risk Management';
    } else {
      document.title = pathValue
        .split('-')
        .map((val) => {
          return `${val[0].toUpperCase()}${val.substring(1).toLowerCase()}`;
        })
        .join(' ');
    }

    // const docTitle = `${path
    //   ?.substring(1)
    //   ?.split('-')
    //   ?.at(0)
    //   ?.toUpperCase()} ${path?.split('-')?.at(1)?.toUpperCase()}`;

    // if (path != '/') {
    //   document.title = docTitle;
    // }
  }, [location]);

  return (
    <div className={styles.wrapper}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/risk-transfer" element={<RiskTransfer />} />
        <Route path="/report" element={<ReportPage />} />
      </Routes>

      <div className={styles.footer} id="footer"></div>
      {window.location.href.includes('localhost:3001') && (
        <div className={styles.tester} id="tester"></div>
      )}
    </div>
  );
};

export default App;
